import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { FacebookMarketingService } from './facebook-marketing.service';
import { GoogleMarketingService } from './google-marketing.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class CookieConsentService {
  get areCookiesAllowed() {
    return this.storageService.getPersistent('cookieConsent') == 'true';
  }

  get hasCookieConsentBeenDenied() {
    return this.storageService.getPersistent('cookieConsent') != null;
  }

  constructor(
    private googleMarketingService: GoogleMarketingService,
    private facebookMarketingService: FacebookMarketingService,
    private storageService: StorageService
  ) {}

  public allowCookies(): void {
    this.storageService.setPersistent('cookieConsent', true);
    this.runCookieDependentServices();
  }

  public denyCookies(): void {
    this.storageService.setPersistent('cookieConsent', false);
  }

  public runCookieDependentServices(): void {
    this.googleMarketingService.initialize();

    if (Capacitor.isNativePlatform()) {
      this.facebookMarketingService.initialize();
    }
  }
}
